<template>
  <!-- 盒子管理-保低配置-系数配置 -->
  <div v-if="$route.query.pv" class="form-box">
    <!-- header头部 -->
    <header>
      <!-- <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="">按钮</el-button>
        </el-form-item>
      </el-form> -->
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-form ref="form" :model="formData" label-width="120px">
        <h1>福利折损</h1>
        <el-form-item label="自动红包">
          <el-input
            v-model="formData.auto_red"
            placeholder="请输入数值"
          ></el-input>
        </el-form-item>
        <el-form-item label="手动红包">
          <el-input
            v-model="formData.manual_red"
            placeholder="请输入数值"
          ></el-input>
        </el-form-item>
        <el-form-item label="赠送钻石">
          <el-input
            v-model="formData.account_balance"
            placeholder="请输入数值"
          ></el-input>
        </el-form-item>
        <el-form-item label="赠送商城币">
          <el-input
            v-model="formData.shop_balance"
            placeholder="请输入数值"
          ></el-input>
        </el-form-item>
        <el-form-item label="ROLL房奖品">
          <el-input v-model="formData.roll" placeholder="请输入数值"></el-input>
        </el-form-item>
        <el-form-item label="战团红包">
          <el-input v-model="formData.team" placeholder="请输入数值"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'

export default {
  data() {
    return {
      loading: false,//加载动画
      query: {
        page: 1
      },
      formData: {
        account_balance: '',
        auto_red: '',
        manual_red: '',
        roll: '',
        team: '',
        shop_balance: '',
      },
      dataList: undefined, //数据列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      let params = { key: 'bottom_pro_deduction_welfare' }
      getApiData('system_config_enable', params).then(res => {
        if (res) {
          this.formData = res
        }
      }).finally(() => {
      })
    },
    submit() {
      //保存新用户配置
      for (let item in this.formData) {
        if (this.formData[item] > 1) {
          this.$message.error("只能填写0-1之间的数")
          return
        }
      }

      let params = {
        key: 'bottom_pro_deduction_welfare',
        val: this.formData
      }
      patchApiData('system_config_enable', params).then(res => {
        this.$message.success("保存成功！")
        this.getData()//刷新
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData();
    },
  }

}
</script>
<style lang="less" scoped>
.form-box {
  header {
  }

  .body-box {
    width: 400px;
  }
}
</style>